import React, { useEffect, useState } from "react";

function extractYoutubeId(html) {
  const match = html && html.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]+)/);
  return match ? match[1] : null;
}

function PopupBanner() {
  const [popup, setPopup] = useState(null);
  const [visible, setVisible] = useState(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const BASE = (
      process.env.REACT_APP_API_BASE_URL || "http://localhost:5000"
    ).replace(/\/+$/, "");

    fetch(`${BASE}/api/popup/popups`)
      .then((r) => r.json())
      .then(({ popups }) => {
        if (!popups || popups.length === 0) return;
        const first = popups[0];
        const dismissedKey = `demirsan-popup-dismissed-${first.id}`;
        if (sessionStorage.getItem(dismissedKey)) return;
        setPopup(first);
        setVisible(true);
      })
      .catch(() => {});
  }, []);

  const close = () => {
    if (popup) {
      sessionStorage.setItem(`demirsan-popup-dismissed-${popup.id}`, "1");
    }
    setVisible(false);
    setPlaying(false);
  };

  useEffect(() => {
    if (!visible) return;
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [visible]);

  if (!visible || !popup) return null;

  const videoId = extractYoutubeId(popup.description);
  if (!videoId) return null;

  const thumbUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  const watchUrl = `https://www.youtube.com/watch?v=${videoId}`;
  const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;

  return (
    <>
      <style>{`
        .dsn-popup-overlay {
          position: fixed;
          inset: 0;
          z-index: 999999;
          background: rgba(0, 0, 0, 0.78);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: dsn-fade-in 0.22s ease;
        }
        @keyframes dsn-fade-in {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes dsn-slide-up {
          from { transform: translateY(28px); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
        .dsn-popup-box {
          position: relative;
          background: #fff;
          border-radius: 16px;
          overflow: visible;
          max-width: 900px;
          width: 100%;
          padding: 20px 20px 0 20px;
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5);
          animation: dsn-slide-up 0.25s ease;
        }
        .dsn-popup-close {
          position: absolute;
          top: -13px;
          right: -13px;
          z-index: 10;
          background: #e20614;
          border: 2.5px solid #fff;
          color: #fff;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          font-size: 15px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 3px 10px rgba(0,0,0,0.3);
          transition: background 0.2s, transform 0.15s;
          line-height: 1;
        }
        .dsn-popup-close:hover {
          background: #b50010;
          transform: scale(1.1);
        }
        .dsn-popup-inner {
          border-radius: 10px;
          overflow: hidden;
        }
        .dsn-popup-video-wrap {
          position: relative;
          width: 100%;
          aspect-ratio: 16 / 9;
          background: #000;
          cursor: pointer;
        }
        .dsn-popup-thumb {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }
        .dsn-popup-video-wrap:hover .dsn-popup-thumb {
          transform: scale(1.03);
        }
        .dsn-popup-thumb-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.28);
          transition: background 0.25s;
        }
        .dsn-popup-video-wrap:hover .dsn-popup-thumb-overlay {
          background: rgba(0,0,0,0.18);
        }
        .dsn-popup-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 72px;
          height: 72px;
          background: rgba(226, 6, 20, 0.92);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 24px rgba(226,6,20,0.45);
          transition: transform 0.2s, background 0.2s;
        }
        .dsn-popup-video-wrap:hover .dsn-popup-play {
          transform: translate(-50%, -50%) scale(1.1);
          background: #e20614;
        }
        .dsn-popup-play svg {
          width: 28px;
          height: 28px;
          fill: #fff;
          margin-left: 4px;
        }
        .dsn-popup-video-label {
          position: absolute;
          bottom: 16px;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(0,0,0,0.6);
          backdrop-filter: blur(6px);
          color: #fff;
          font-size: 13px;
          font-weight: 500;
          padding: 5px 14px;
          border-radius: 20px;
          white-space: nowrap;
          letter-spacing: 0.3px;
        }
        .dsn-popup-iframe {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }
        .dsn-popup-footer {
          background: #fff;
          padding: 16px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
        }
        .dsn-popup-title {
          font-size: 15px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .dsn-popup-yt-btn {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          background: #ff0000;
          color: #fff;
          font-size: 13.5px;
          font-weight: 600;
          padding: 9px 18px;
          border-radius: 7px;
          text-decoration: none;
          transition: background 0.2s, transform 0.15s;
          letter-spacing: 0.3px;
        }
        .dsn-popup-yt-btn:hover {
          background: #cc0000;
          color: #fff;
          text-decoration: none;
          transform: translateY(-1px);
        }
        @media (max-width: 600px) {
          .dsn-popup-box {
            padding: 12px 12px 0 12px;
          }
          .dsn-popup-play {
            width: 54px;
            height: 54px;
          }
          .dsn-popup-play svg {
            width: 22px;
            height: 22px;
          }
          .dsn-popup-footer {
            flex-direction: column;
            align-items: stretch;
            text-align: center;
          }
          .dsn-popup-yt-btn {
            justify-content: center;
          }
        }
      `}</style>

      <div
        className="dsn-popup-overlay"
        onClick={(e) => { if (e.target === e.currentTarget) close(); }}
      >
        <div className="dsn-popup-box">
          <button className="dsn-popup-close" onClick={close} aria-label="Kapat">✕</button>

          <div className="dsn-popup-inner">
            <div className="dsn-popup-video-wrap" onClick={() => setPlaying(true)}>
              {playing ? (
                <iframe
                  className="dsn-popup-iframe"
                  src={embedUrl}
                  title={popup.title || "Video"}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <>
                  <img className="dsn-popup-thumb" src={thumbUrl} alt={popup.title || "Video"} />
                  <div className="dsn-popup-thumb-overlay" />
                  <div className="dsn-popup-play">
                    <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
                  </div>
                  <span className="dsn-popup-video-label">Videoyu İzle</span>
                </>
              )}
            </div>

            <div className="dsn-popup-footer">
              {popup.title && (
                <p className="dsn-popup-title">{popup.title}</p>
              )}
              <a
                href={watchUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="dsn-popup-yt-btn"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                YouTube'da İzle
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PopupBanner;
